import { serviceNames, diContainer } from '../../service-setup/diContainer';
import { ProductRepository } from '../repositories/ProductRepository';
import { IContentItem } from '../../exported/product-grid-wrapper/ProductGridWrapper';
import { Product } from '../domain/entities/Product';
import { ProductGridService } from '../domain/services/ProductGridService';

export class PopulateProductsFromServerState {
    private productRepository: ProductRepository;
    private productGridService?: ProductGridService;
    private content?: IContentItem[];
    private stateProducts: Product[];

    constructor(
        stateProducts: Product[],
        productGridService?: ProductGridService,
        content?: IContentItem[]
    ) {
        this.productRepository = diContainer.get(serviceNames.productRepository);
        this.productGridService = productGridService;
        this.stateProducts = stateProducts;
        this.content = content;
    }

    public execute = () => {
        if (this.content && this.productGridService) {
            this.productGridService.setInlineContent(this.content);
        }
        this.productRepository.setProducts(this.stateProducts.map(Product.fromPlainObject));
    };
}
